export const fieldsAddress = [
    'cep',
    'ufEndereco',
    'municipio',
    'logradouro',
    'bairro'
] as const

export const attributesAddressToReset = {
    ufEndereco: '',
    municipio: '',
    logradouro: '',
    bairro: ''
} as const
